import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Response } from '@angular/http';
import { MOCK_API } from '../config/api.config';
import { HttpInterceptorService, RESTService } from '@covalent/http';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

import { MdSnackBar } from '@angular/material';
import { Profesional, HojaDeConsulta } from '../models/';
import { environment } from '../environments/environment';

@Injectable()
export class LoginService extends RESTService<any> {

  isLoggedIn: boolean = false;
  profesional: any;
  consulta: HojaDeConsulta;
  agenda: string;
  anamnesis: string;
  motivo: string;
  patron: string;
  colegiado: string;
  cias: string;
  valoracionTecnica: string;
  fechaHojaConsulta: Date;
  transient: any;

  // store the URL so we can redirect after logging in
  redirectUrl: string;

  constructor(private snackbar: MdSnackBar, private _http: HttpInterceptorService) {
    super(_http, {
      baseUrl: MOCK_API,
      path: '/login',
    });
    this.fechaHojaConsulta = new Date();
  }

  mostrarMensaje(message: string, action: string, duration: number = 2000): void {
    this.snackbar.open(message, action, {
      duration: duration,
    });
  }

  login(usuario: string, clave: string): Observable<any> {
    // TSLint -> console.log('LoginService -> login()');
    // Parametros fijos
    let params: any = {
      usuario: usuario,
      password: clave,
    };

    return this._http.post(environment.api_host + 'login/doLogin', params).map((res: Response) => {
      let message: any = res.json().respuesta.mensajeError;
      switch (message.Id_Mensaje) {
        case 30: this.mostrarMensaje('Atención, su contraseña caducará pronto.', 'OK', 6000);
                 this.isLoggedIn = true;
                 this.profesional = res.json().respuesta;
                 break;
        case 1: this.isLoggedIn = true;
                this.profesional = res.json().respuesta;
                break;
        case 42: this.mostrarMensaje(message.Texto, 'OK', 6000);
                 this.isLoggedIn = false;
                 this.profesional = res.json().respuesta;
                 break;
        case 44: this.mostrarMensaje(message.Texto, 'OK', 6000);
                 this.isLoggedIn = false;
                 this.profesional = res.json().respuesta;
                 break;
        default: this.isLoggedIn = false;
                 this.mostrarMensaje('Error comprobando datos de acceso', 'OK', 6000);
      }
      return res.json();
    }).catch((res: Response) => { return Observable.throw(res); });
  }

  updatePassword(profesional: any): Observable<any> {
    return this._http.post(environment.api_host + 'login/doUpdatePassword', {profesional: profesional}).map((res: Response) => {
      if (!res.ok) {
        this.mostrarMensaje('No se ha podido realizar la operación', 'OK', 6000);
      } else {
        this.mostrarMensaje('Contraseña modificada correctamente', 'OK', 6000);
      }
      return res.json();
    }).catch((res: Response) => { return Observable.throw(res); });
  }

  logout(): void {
    this.isLoggedIn = false;
    this.profesional = '';
    this.consulta = undefined;
    this.fechaHojaConsulta = undefined;
    this.transient = undefined;
  }
}



// WEBPACK FOOTER //
// ./src/services/login.service.ts